import React from 'react'
import { Album } from '../types'
import { formatDate } from '../utils/date'

interface AlbumCardProps {
  album: Album
  onDelete?: (id: number) => void
  isAdmin?: boolean
}

const AlbumCard: React.FC<AlbumCardProps> = ({ album, onDelete, isAdmin }) => {
  return (
    <div className="group relative bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
      {/* 封面图片 */}
      <div className="aspect-w-16 aspect-h-9 bg-gray-200">
        {album.cover_image ? (
          <img
            src={album.cover_image}
            alt={album.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-100 to-purple-100">
            <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        )}
      </div>

      {/* 专辑信息 */}
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{album.title}</h3>
        {album.description && (
          <p className="text-sm text-gray-600 line-clamp-2">{album.description}</p>
        )}
        <p className="text-xs text-gray-500 mt-2">{formatDate(album.created_at)}</p>
      </div>

      {/* 管理员操作 */}
      {isAdmin && (
        <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => onDelete?.(album.id)}
            className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
            aria-label="删除相册"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      )}
    </div>
  )
}

export default AlbumCard
